import { render } from "./GlobalTransactionPaypalView.vue?vue&type=template&id=a84536ba"
import script from "./GlobalTransactionPaypalView.vue?vue&type=script&lang=js"
export * from "./GlobalTransactionPaypalView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__